// @ts-nocheck
/* eslint-enable */
// App
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

// Dependent Components
import MobileLinkGroup from './MobileLinkGroup';
import DesktopLinkGroup from './DesktopLinkGroup';

// Misc utils
import * as S from './styles';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger('modules/navigation/footer/seofooter');

const SeoFooter = ({ hideDivider = false, shortDivider, className }) => {
  // Redux
  const seoLinks = useSelector((state) => state.seo.seoFooterLinks);
  const isMobile = useSelector((state) => state.app.device.isMobile);
  const pathname = useSelector((state) => state.location.current.pathname);

  // Filter out any links with /undefined/ in the URL to prevent displaying broken links
  const filteredSeoLinks = useMemo(() => {
    if (!seoLinks.groups) {
      return seoLinks;
    }

    const filteredGroups = seoLinks.groups
      .map((group) => {
        const validLinks = group.links.filter((link) => {
          const hasUndefinedInUrl = link.uriV2 && link.uriV2.includes('/undefined/');

          if (hasUndefinedInUrl) {
            logger?.warn('Filtered out SEO footer link with /undefined/ in URL', {
              pathname,
              linkName: link.name,
              linkUrl: link.uriV2,
              groupHeader: group.header,
            });
          }

          return !hasUndefinedInUrl;
        });

        return {
          ...group,
          links: validLinks,
        };
      })
      .filter((group) => group.links.length > 0); // Remove groups with no valid links

    return {
      ...seoLinks,
      groups: filteredGroups,
    };
  }, [seoLinks, pathname]);

  return (
    <S.SeoFooterArticle className={className}>
      <S.SemanticDivider shortDivider={shortDivider} hideDivider={hideDivider} />
      <S.SeoFooterSectionList>
        {filteredSeoLinks.groups &&
          filteredSeoLinks.groups.map((group) => {
            const hasLinks = group.links.length > 0;

            if (!hasLinks) {
              return null;
            }

            return hasLinks && isMobile ? (
              <MobileLinkGroup
                header={group.header}
                links={group.links}
                key={`seo-footer-mobile-link-group-${group.header}`}
              />
            ) : (
              <DesktopLinkGroup
                header={group.header}
                links={group.links}
                key={`seo-footer-desktop-link-group-${group.header}`}
              />
            );
          })}
      </S.SeoFooterSectionList>
    </S.SeoFooterArticle>
  );
};

export default SeoFooter;
